/* src/app/modules_v2/finance/payment-card/components/credit-card-list/credit-card-list.components.css */
.quick-filter {
  display: flex;
  align-items: center;
  gap: 8px;
}
/*# sourceMappingURL=credit-card-list.components.css.map */
